import { useCallback, useEffect, useState } from 'react';
import './App.css';

const SECTION_IDS = ['about', 'courses', 'who-should-attend', 'what-to-expect','Project', 'contact'];

const COURSE_DATA = [
    {
    title: <h3>BIM for Architectural & Structural</h3>,
    image: 'https://bimtraining.net/wp-content/uploads/2026/04/arch.jpg',
    
    features: [
      { label: 'Duration:', value: '6 months' },
      { label: 'Assessments:', value: ' 4 no.s' },
      { label: 'Internship with stipend:', value: ' 3 months' },
      { label: 'Softwares covered :', value: ' Revit, AutoCAD, Navisworks, Autodesk Construction Cloud' },
      { label: 'Eligibility: ', value: 'B.Tech / M.Tech / B.Arch / M.Arch' },  
    ],
  },
  {
    title: <h3>BIM for MEP</h3>,
    image: 'https://bimtraining.net/wp-content/uploads/2026/04/mep.jpg',
    features: [
      { label: 'Duration:', value: '6 months' },
      { label: 'Assessments:', value: ' 4 no.s' },
      { label: 'Internship with stipend:', value: ' 3 months' },
      { label: 'Softwares covered :', value: ' Revit, AutoCAD, Navisworks, Autodesk Construction Cloud' },
      { label: 'Eligibility: ', value: ' B.Tech / M.Tech / B.Arch / M.Arch ' },  



    ],
  },
  {
    title: <h3>BIM for Façade Design</h3>,
    image: 'https://bimtraining.net/wp-content/uploads/2026/04/facade.jpg',
    features: [
     { label: 'Duration:', value: '6 months' },
      { label: 'Assessments:', value: ' 4 no.s' },
      { label: 'Internship with stipend:', value: ' 3 months' },
      { label: 'Softwares covered :', value: ' Revit, AutoCAD, Navisworks, Autodesk Construction Cloud' },
      { label: 'Eligibility: ', value: '   B.Tech / M.Tech / B.Arch / M.Arch ' },  
    ],
  },

];

function App() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState('about');
  const [activeTab, setActiveTab] = useState(0);
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [formStatus, setFormStatus] = useState({ message: '', type: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const scrollToSection = useCallback((id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  }, []);

  useEffect(() => {
    const onScroll = () => {
      setIsScrolled(window.scrollY > 40);
      const offset = window.scrollY + 140;
      let current = 'about';
      for (const sectionId of SECTION_IDS) {
        const el = document.getElementById(sectionId);
        if (el && el.offsetTop <= offset) {
          current = sectionId;
        }
      }
      setActiveSection(current);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

const WP_API_URL = 'https://bimtraining.net/wp-json/bim/v1/contact';
 
// Replace your handleSubmit with this
const handleSubmit = async (e) => {
  e.preventDefault();
  setIsSubmitting(true);
  setFormStatus({ message: '', type: '' });
  try {
    const response = await fetch(WP_API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    if (response.ok && data.success) {
      setFormStatus({ message: 'Thank you! We will get back to you soon.', type: 'success' });
      setFormData({ name: '', email: '', message: '', website: ''   });
    } else {
      setFormStatus({ message: data.message || 'Something went wrong.', type: 'error' });
    }
  } catch (err) {
    setFormStatus({ message: 'Network error. Please try again.', type: 'error' });
  } finally {
    setIsSubmitting(false);
  }
};

  return (
    <div className="bim-training-page">
      {/* Navigation */}
      <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
        <div className="nav-container">
          <div className="logo"  >
    <a 
  href="#hero-section"
  onClick={(e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }}
  style={{ cursor: 'pointer' }}
>
  <img 
    src={
      isScrolled
        ? 'https://bimtraining.net/wp-content/uploads/2026/04/logo-scaled.png'
        : 'https://bimtraining.net/wp-content/uploads/2026/04/logo-white-scaled.png'
    }
    alt="BIM Training"  
  />
</a>
          </div>
          <ul className="nav-menu">
            <li onClick={() => scrollToSection('about')} className={activeSection === 'about' ? 'active' : ''}>About</li>
            <li onClick={() => scrollToSection('courses')} className={activeSection === 'courses' ? 'active' : ''}>Course Offered</li>
            <li onClick={() => scrollToSection('who-should-attend')} className={activeSection === 'who-should-attend' ? 'active' : ''}>Who should attend</li>
            <li onClick={() => scrollToSection('what-to-expect')} className={activeSection === 'what-to-expect' ? 'active' : ''}>What to expect</li>
            <li onClick={() => scrollToSection('project')} className={activeSection === 'project' ? 'active' : ''}>Project</li>
            <li onClick={() => scrollToSection('contact')} className={activeSection === 'contact' ? 'active' : ''}>Contact</li>
          </ul>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="hero-section" id="home">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1 className="hero-title">
            <span className="highlight">BIM</span> TRAINING PROGRAM
          </h1>
          <p className="hero-subtitle">
          Advenser Academy is the training and talent development wing of Advenser, built to equip engineering graduates with the skills required in today’s AEC industry. The programs are structured around real project workflows, combining software expertise, domain knowledge, and practical exposure to ensure a smooth transition from learning to working in an engineering environment.
          </p>
          <button type="button" className="cta-button" onClick={() => scrollToSection('contact')}>
            APPLY NOW
            <svg className="arrow-icon" viewBox="0 0 17 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M 0 0 L 20 12.5 L 0 25 Z" fill="white"/>
            </svg>
          </button>
          <div className="software-badges">
          <img src="https://bimtraining.net/wp-content/uploads/2026/04/AUTOcad.png" alt="Autodesk Logo" />
            <img src="https://bimtraining.net/wp-content/uploads/2026/04/REVIT.png" alt="Autodesk Revit Logo" />
            <img src="https://bimtraining.net/wp-content/uploads/2026/04/NAVISWORK.png" alt="Autodesk Navisworks Logo" />
            <img src="https://bimtraining.net/wp-content/uploads/2026/04/construction.png" alt="Autodesk Construction Cloud logo" />
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="about-section" id="about">
        <div className="container">
          <div className="about-grid">
            <div className="experience-box">
              <div className="experience-number">18</div>
              <div className="experience-text">
                <p>Years of Experience in BIM</p>
                {/* <span className="since">Since 2007</span> */}
              </div>
            </div>
            <div className="about-content">
              <h2 className="section-title gradient-text">
               BIM Training That Reflects Real Project Work
              </h2>
              <p className="about-description">
              The courses are crafted to mirror the workflows and domains followed at Advenser, 
              a company with nearly two decades of experience delivering projects globally across the AEC industry using BIM.
              </p>
               <p className="about-description">This includes how models are developed, how drawings are prepared for 
                execution, and how teams coordinate across disciplines within a project environment.</p>
                 <p className="about-description">The focus is on understanding the workflow, the expected outputs, and the way
                   work is handled in real projects so that you are prepared to contribute, not just learn tools.</p>
           </div> 
          </div>



        </div>
      </section>


      <section className="why-choose-section">
        <div className="container why-choose">


<div className='why-choose-content'>

  <p className="about-description ">
              <h2 className="challenge-statement gradient-text">
Why Join Advenser Academy for BIM Training?</h2>
Many engineering graduates step into the industry without exposure to live project environments, cross-disciplinary coordination,
 or globally followed BIM standards. At the same time, companies are looking for professionals who can adapt quickly and contribute from 
 the start.
<br></br>
At Advenser Academy, the training is structured to bridge this gap. The programs combine BIM workflows, modeling, coordination, 
and documentation within a guided learning approach that reflects how work is handled in engineering teams.
<br></br>
The focus is on building practical understanding and clarity—so you are better prepared to take on BIM roles with confidence.


          </p></div>
          
          
      <div className='why-choose-image'>
      
          <img src="http://bimtraining.net/wp-content/uploads/2026/04/about-img.jpg" alt="BIM Training Program" />

        </div>    
          
          
          </div>
      </section>

     {/* Course Offered Section */}
      <section className="courses-section" id="courses">
        <div className="container">
          <h2 className="section-title-main">Course Offered</h2>

          <div className="course-tabs">
            {COURSE_DATA.map((course, index) => (
              <button
                key={course.title}
                type="button"
                className={`tab-button ${activeTab === index ? 'active' : ''}`}
                onClick={() => setActiveTab(index)}
              >
                {course.title}
              </button>
            ))}
          </div>

          <div className="course-details">
            <div className="course-image">
              <img src={COURSE_DATA[activeTab].image} alt={COURSE_DATA[activeTab].title} />
            </div>
            <div className="course-info">
              <h3 className="course-title gradient-text">{COURSE_DATA[activeTab].title}</h3>
              <ul className="course-features">
                {COURSE_DATA[activeTab].features.map((feature) => (
                  <li key={`${feature.label}-${feature.value}`}>
                    <span className="arrow">{'\u27A4'}</span>
                    <strong>{feature.label}</strong> {feature.value}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* What You Will Learn */}
          <h3 className="subsection-title gradient-text">Our Differentiators</h3>
          <div className="benefits-grid">
            <div className="benefit-card">
              <div className="benefit-icon">
                <img src="https://bimtraining.net/wp-content/uploads/2026/04/soft-icon.png" alt="Expert-Led Software Training" />
              </div>
              <h4>Expert-Led Software Training</h4>
              <p>In-depth training on leading BIM platforms such as Autodesk Revit, Navisworks, and AutoCAD, delivered by professionals with extensive experience in the construction and AEC sectors.</p>
            </div>
            <div className="benefit-card">
              <div className="benefit-icon">
                <img src="https://bimtraining.net/wp-content/uploads/2026/04/indenship-icon.png" alt="Real Project Experience" />
              </div>
              <h4>Real Project Experience</h4>
              <p>Develop hands-on expertise by working on industry-based projects under the supervision of experienced mentors, enabling a clear understanding of real-world BIM applications.</p>
            </div>
            <div className="benefit-card">
              <div className="benefit-icon">
                <img src="https://bimtraining.net/wp-content/uploads/2026/04/project-icon.png" alt="Industry-Ready Opportunity" />
              </div>
              <h4>Industry-Ready Opportunity</h4>
              <p>Build strong industry readiness through training aligned with global standards, current practices, and the evolving demands of the AEC sector.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Who Should Attend Section */}
      <section className="who-should-attend-section" id="who-should-attend">
        <div className="container">
          <div className="who-attend-grid">
            <div className="who-attend-image">
              <img src="https://bimtraining.net/wp-content/uploads/2026/04/students.png" alt="BIM Training Program" />
            </div>
            <div className="who-attend-content">
              <h2 className="section-title-main white">Who Should Attend</h2>
              <p className="who-attend-intro">
               This program is designed for students and professionals looking to build or strengthen their skills in BIM, 
               aligned with their engineering discipline and preparing for careers in modern construction workflows.
              </p>
              <ul className="who-attend-list">
                <li>Fresh graduates in Architecture, Civil, Mechanical, and Electrical engineering looking to specialize in BIM </li>
                <li>Early-career professionals aiming to improve modeling, coordination, and project-related skills while upskilling with the latest tools and workflows </li>
                <li>Students seeking to build a strong foundation in BIM and its practical applications</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* What to Expect Section */}
          <section className="what-to-expect-section" id="what-to-expect">
        <div className="container">
          <h2 className="section-title-main">What to Expect</h2>
          <div className="expectations-grid">
            <div className="expectation-item">
              <div className="expectation-number">1</div>
              <p>	Theory & Practical Insights in BIM</p>
            </div>
            <div className="expectation-item">
              <div className="expectation-number">2</div>
              <p>Real-time scenarios & BIM Projects</p>
            </div>
            <div className="expectation-item">
              <div className="expectation-number">3</div>
              <p>3 Months of Intensive BIM Training</p>
            </div>
            <div className="expectation-item">
              <div className="expectation-number">4</div>
              <p>3 Months of Hands-on internship</p>
            </div>
            <div className="expectation-item">
              <div className="expectation-number">5</div>
              <p>Mentoring from Industry Experts</p>
            </div>
          </div>
        </div>



     
        
    



      </section>


      <section className="project-section" id="project">
     <h2 className="section-title-main">International BIM Projects Across Sectors</h2>
          <div className="project-grid">

            <div className="project-card">
              <div className="project-icon">
                <img src="http://bimtraining.net/wp-content/uploads/2026/04/project-1.jpg" alt="Rebar Detailing for a Museum Project" />
              </div>
              <h4>Rebar Detailing for a Museum Project, UAE</h4>
             
            </div>
            <div className="project-card">
              <div className="project-icon">
                <img src="http://bimtraining.net/wp-content/uploads/2026/04/project-2.jpg" alt="MEP BIM Modeling for Sports Facility" />
              </div>
              <h4>MEP BIM Modeling for Sports Facility</h4>
             
            </div>
            <div className="project-card">
              <div className="project-icon">
                <img src="http://bimtraining.net/wp-content/uploads/2026/04/project-3.jpg" alt="Mixed-Use Building Project" />
              </div>
              <h4>Mixed-Use Building Project, UAE</h4>
             
            </div>
               <div className="project-card">
              <div className="project-icon">
                <img src="http://bimtraining.net/wp-content/uploads/2026/04/project-4.jpg" alt="Multi-Storey Residential Project" />
              </div>
              <h4>Multi-Storey Residential Project, AUS</h4>
              
            </div>

            </div>


      </section>


      <section className="BIM-section" id="BIM-sec">


        <div className='bim-grid'>
        <div>
          <h2>How BIM is Used in Engineering Projects</h2>
          <p>In engineering projects, BIM follows a structured workflow that supports design development, detailing, coordination, and execution across different sectors.</p>
        </div>


            <div>
              <div className='bim-box'>
               <img src="http://bimtraining.net/wp-content/uploads/2026/04/icon-bim-1.png" alt="Multi-Storey Residential Project" />
          
 <h4>Model Development</h4>
 <p>3D models are created based on project requirements across disciplines such as architecture, structural systems, MEP services, façade, and other components.</p>
 </div>
  <div className='bim-box'>
  <img src="http://bimtraining.net/wp-content/uploads/2026/04/icon-bim-2.png" alt="Multi-Storey Residential Project" />
 <h4>Drawing & Documentation</h4>
 <p>These models are used to generate drawings and documentation required for construction and fabrication.</p>
</div>

            </div>
                <div>
                 <div className='bim-box'>
                   <img src="http://bimtraining.net/wp-content/uploads/2026/04/icon-bim-3.png" alt="Multi-Storey Residential Project" />
<h4>Coordination & Clash Detection</h4>
<p>Models from different disciplines are combined to identify and resolve conflicts before construction begins.</p>
</div>
  <div className='bim-box'>
 <img src="http://bimtraining.net/wp-content/uploads/2026/04/icon-bim-4.png" alt="Multi-Storey Residential Project" />

<h4>Project Use & Execution</h4>
<p>The coordinated models and drawings are used by project teams for planning, fabrication, and on-site execution.</p>

</div>
                </div>

</div>


      </section>


      {/* Contact Section */}
      <section className="contact-section" id="contact">

 
                           <div className="contact-header">
          <div className="contact-info">
            <img src="https://bimtraining.net/wp-content/uploads/2026/04/location.png" alt="Location" className="location-icon" />
            <div className="address">
              <strong>Advenser Academy</strong><br />
              Unit No. 019, Ground Floor<br />
              Lulu Cyber Tower 1<br />
              Infopark Phase 1, Kakkanad<br />
              Kochi – 682042
            </div>
            <div className="social-icons">
                <a href="https://www.linkedin.com/showcase/advenser-academy/" target="_blank" rel="noopener noreferrer">
    <img 
      src="https://bimtraining.net/wp-content/uploads/2026/04/icon-linkedin.png" 
      alt="LinkedIn - Advenser Academy" 
    />
  </a>

  <a href="https://www.instagram.com/bimtraining_aa" target="_blank" rel="noopener noreferrer">
    <img 
      src="https://bimtraining.net/wp-content/uploads/2026/04/icon-insta.png" 
      alt="Instagram - Advenser Academy" 
    />
  </a>

  <a href="https://www.facebook.com/AdvenserBIM" target="_blank" rel="noopener noreferrer">
    <img 
      src="https://bimtraining.net/wp-content/uploads/2026/04/icon-fb.png" 
      alt="Facebook - Advenser Academy" 
    />
  </a>

  <a href="https://www.youtube.com/@bimtraining_aa" target="_blank" rel="noopener noreferrer">
    <img 
      src="https://bimtraining.net/wp-content/uploads/2026/04/icon-youtube.png" 
      alt="YouTube - Advenser Academy" 
    />
  </a>
            </div>
          </div>
        </div>


        <div className="contact-form-wrapper">
          <div className="map-container">



            <div  className="map-container-map">
  <iframe
    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3929.083869597304!2d76.365798!3d10.009931!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b080bce8c7f647d%3A0x2b51dd824fa8b63f!2sAdvenser%20Academy%20-%20BIM%20Training%20in%20Kochi!5e0!3m2!1sen!2sin!4v1776941070858!5m2!1sen!2sin"
    style={{ border: 0, width: "100%", height: "100%" }}
    allowFullScreen
    loading="lazy"
    referrerPolicy="no-referrer-when-downgrade"
    title="Advenser Academy Location"
  ></iframe>

            
</div>

            
            <div className="contact-form-container">
            <form onSubmit={handleSubmit} className="contact-form">
              <h3>Contact Us</h3>

              {formStatus.message && (
                <div
                  className={`form-status ${formStatus.type}`}
                  style={{
                    padding: '1rem',
                    marginBottom: '1rem',
                    borderRadius: '4px',
                    backgroundColor: formStatus.type === 'success' ? '#d4edda' : '#f8d7da',
                    color: formStatus.type === 'success' ? '#155724' : '#721c24',
                    border: `1px solid ${formStatus.type === 'success' ? '#c3e6cb' : '#f5c6cb'}`,
                  }}
                >
                  {formStatus.message}
                </div>
              )}

            <div className="form-group-top">

              <div className="form-group">
                <label htmlFor="contact-name">Name*</label>
                <input
                  id="contact-name"
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleFormChange}
                  required
                  disabled={isSubmitting}
                />
              </div>
              <div className="form-group">
                <label htmlFor="contact-email">Email*</label>
                <input
                  id="contact-email"
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleFormChange}
                  required
                  disabled={isSubmitting}
                />
              </div>
           </div>
           <input type="text" name="website" style={{ display: "none" }} />

              <div className="form-group">
                <label htmlFor="contact-message">Message</label>
                <textarea
                  id="contact-message"
                  name="message"
                  rows={4}
                  value={formData.message}
                  onChange={handleFormChange}
                  disabled={isSubmitting}
                />
              </div>
              <button type="submit" className="submit-button" disabled={isSubmitting}>
                {isSubmitting ? 'Submitting...' : 'Submit'}
              </button>
            </form>
          </div>



          </div>        
        </div>



        <footer className="footer">
          <div className='footer-grid'>
            <div className='footer-logo'>
              <img src="https://bimtraining.net/wp-content/uploads/2026/04/logo-white-scaled.png" alt="BIM Training" />
            </div>
                      <div className='footer-Description'>
                        <h4>BIM Training</h4>
                
                        Advenser Academy offers structured BIM training designed to prepare engineering graduates for real-world project environments.
                         The training program goes beyond software instruction and focuses on practical application, coordination workflows, 
                         and industry standards used in live construction projects.
                      </div>
                      <div className='footer-links'>
                            <ul className="nav-menu-footer">
            <li onClick={() => scrollToSection('about')} className={activeSection === 'about' ? 'active' : ''}>About</li>
            <li onClick={() => scrollToSection('courses')} className={activeSection === 'courses' ? 'active' : ''}>Course Offered</li>
            <li onClick={() => scrollToSection('who-should-attend')} className={activeSection === 'who-should-attend' ? 'active' : ''}>Who should attend</li>
            <li onClick={() => scrollToSection('what-to-expect')} className={activeSection === 'what-to-expect' ? 'active' : ''}>What to expect</li>
            <li onClick={() => scrollToSection('project')} className={activeSection === 'project' ? 'active' : ''}>Project</li>
            <li onClick={() => scrollToSection('contact')} className={activeSection === 'contact' ? 'active' : ''}>Contact</li>
          </ul>
                      </div>
          </div>
          <p>© Copyright 2026 Advenser Academy | Privacy Policy</p>
<a
  href="https://wa.me/918089990013"
  className="wa-float-btn"
  id="whatsapp_click"
  target="_blank"
  rel="noopener noreferrer"
  aria-label="Chat with us on WhatsApp"
>
  <span className="wa-float-icon">
    <img
      src="https://bimtraining.net/wp-content/uploads/2026/04/whatsapp-icon.png"
      alt="WhatsApp Chat"
    />
  </span>
</a>
        </footer>
      </section>
    </div>
  );
}

export default App;
